export enum OperationalUnitType {
  CASH_TILL = "CASH_TILL",
  BRANCH_STORE = "BRANCH_STORE",
  RETAILER = "RETAILER",
  TRADE_ASSOCIATION = "TRADE_ASSOCIATION",
  COUNTRY = "COUNTRY",
  DEPARTMENT = "DEPARTMENT",
  REGION = "REGION",
  BUSINESS_UNIT = "BUSINESS_UNIT",
}
